import { createContext } from 'react';
import { useContext } from 'react';

// @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
export const TimelinePermissionsContext = /*#__PURE__*/createContext();
export const useTimelinePermissions = () => {
  const permissions = useContext(TimelinePermissionsContext);
  if (permissions === undefined) {
    throw new Error('TimelinePermissionsContext has not been set');
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentUserCanEdit' does not exist on ty... Remove this comment to see the full error message
  const {
    currentUserCanEdit,
    currentUserCanCommunicate
  } = permissions;
  return {
    currentUserCanEdit,
    currentUserCanCommunicate
  };
};